module.exports = __webpack_public_path__ + "img/Img21_210852_CeEt-9-11A7-1127.b62cd8c4.jpg";